import { render, staticRenderFns } from "./ModalVerifyIdentity.vue?vue&type=template&id=f0083c4e&"
import script from "./ModalVerifyIdentity.vue?vue&type=script&lang=js&"
export * from "./ModalVerifyIdentity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports